import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import toast from "react-hot-toast";

import { loginConfirm } from "app/api/busha";
import { GenericErrorResponse } from "app/api/types";
import parseError from "app/lib/parseError";

export default function useConfirmLogin() {
  const { isLoading, data, mutate, error } = useMutation(loginConfirm, {
    onError(error: AxiosError<GenericErrorResponse>) {
      const errorMessage = parseError(error) as string;
      toast.error(errorMessage);
    },
  });

  return {
    isLoading,
    data: data?.data,
    confirmLogin: mutate,
    error: error ? (parseError(error) as string) : null,
  };
}
